import { curry, map as rMap, addIndex, filter, is, when } from 'ramda';
import { concat as strConcat } from '../strings';

export const map = addIndex(rMap);
export const concat = strConcat;
export const filterFalsy = filter(Boolean);

/**
 * @param {Array.<T>} a
 * @param {T} something
 */
export const oneOf = curry((a, something) => a.find((l) => l === something));

/**
 * @param {Array.<T>|T} something
 * @param {Array.<T>} array
 */
export const ensureArray = when(Boolean, (data) =>
  is(Array, data) ? data : [data]
);
